// react
import { useState, useEffect } from "react";
import { useLocation, Redirect } from "react-router-dom";
// shell
import NotFoundPage from "../../shell/components/error/NotFoundPage";
// common
import PageLayout from "../../common/shell/PageLayout";
import TaskLayout from "../../common/shell/TaskLayout";
// me
import { IRootViewModel, RootViewModel } from "./models/models";
import * as actions from "./actions";
import * as openTitleHelper from "./openTitleHelper";

export default function Controller() {
    const [vm, setVm] = useState<IRootViewModel>(new RootViewModel());

    // using query string - /Open/Title?titleNumber=xxx
    // this allows for non URL encoded content to be passed through, as we can't assume callers are always able to url encode
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const details = openTitleHelper.tryGetDetails(params);

    // on mount
    useEffect(() => {
        if (details) actions.initialise(details.titleNumber, setVm);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // invalid details supplied, just redirect to the not-found page
    if (!details) return <NotFoundPage />;

    // resolved
    if (vm.isResolved) {
        // doesn't exist
        if (vm.titleId === undefined) return <NotFoundPage />;

        // exists
        const url = openTitleHelper.getRedirectUri(details, vm.titleId);
        return <Redirect to={url} />;
    }

    // wait
    return (
        <PageLayout title={["Redirecting..."]}>
            <TaskLayout isBusy={vm.isBusy} error={vm.error}>
                <></>
            </TaskLayout>
        </PageLayout>
    );
}
